const descSort = (a: number | string, b: number | string) => +b - +a

export default descSort
